import React from 'react';
import { Box, Typography, Button } from '@mui/material';

/**
 * ApprovalBanner - Banner component for items that need review/approval
 * 
 * @param {string} message - The review message to display
 * @param {function} onApprove - Callback when Approve button is clicked
 * @param {function} onDeny - Callback when Deny button is clicked
 * @param {boolean} disabled - Disables both buttons (during API calls)
 */
const ApprovalBanner = ({
  message,
  onApprove,
  onDeny,
  disabled = false,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffcdd2',
        borderRadius: 1,
        padding: 2,
        mb: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography variant="body1" sx={{ color: '#000000', fontWeight: 500 }}>
        {message}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="contained"
          onClick={onApprove}
          disabled={disabled}
          sx={{
            backgroundColor: '#4caf50',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#45a049',
            },
          }}
        >
          Approve
        </Button>
        <Button
          variant="contained"
          onClick={onDeny}
          disabled={disabled}
          sx={{
            backgroundColor: '#f44336',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#da190b',
            },
          }}
        >
          Deny
        </Button>
      </Box>
    </Box>
  );
};

export default ApprovalBanner;
